<app-grid-editor [maxColumns]="4" [location]="'main'" [type]="'article'"></app-grid-editor>
